import _jsx from "@babel/runtime/helpers/jsx";
var _Text;
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, ButtonToolbar, DisclaimerText, Image, Link, Text } from 'reaxl';
import { footer } from 'axl-config';
import NonstaticSitemap from '../NonstaticSitemap';
import NonstaticFooterLegal from '../NonstaticFooterLegal';
const {
  sitemap,
  social,
  appStore
} = footer;
const renderSocialButton = _ref => {
  let {
    alt,
    src,
    imgHeight,
    imgWidth,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    key: rest.href,
    bsStyle: "link",
    target: "_blank"
  }, rest), /*#__PURE__*/_jsx(Image, {
    src: src,
    alt: "",
    "aria-hidden": "true",
    lazyload: true,
    height: imgHeight,
    width: imgWidth
  }));
};
const renderSocial = data => /*#__PURE__*/_jsx(ButtonToolbar, {
  className: "margin-horizontal-2"
}, void 0, _Text || (_Text = /*#__PURE__*/_jsx(Text, {
  className: "label text-bold text-inverse"
}, void 0, "Follow")), data.map(renderSocialButton));
const renderLegal = (footerLegal, renderThirdParty) => footerLegal || /*#__PURE__*/_jsx(NonstaticFooterLegal, {
  renderThirdParty: renderThirdParty
});
function NonstaticFooter(_ref2) {
  let {
    barContent,
    size = 'lg',
    sitemap: footerSitemap = sitemap,
    social: footerSocial = social,
    appStore: footerAppStore = appStore,
    legal: footerLegal,
    renderThirdParty = true,
    className,
    onClick,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement("footer", Object.assign({
    "data-cmp": "footer",
    className: clsx('footer', className)
  }, rest), /*#__PURE__*/_jsx("div", {
    className: "container-fluid"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "container"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-12"
  }, void 0, barContent)))), /*#__PURE__*/_jsx("div", {
    className: "container-fluid"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "container"
  }, void 0, footerSitemap && /*#__PURE__*/_jsx(NonstaticSitemap, {
    data: footerSitemap,
    collapsed: ['xs', 'sm'].includes(size)
  }), /*#__PURE__*/_jsx("div", {
    className: "app-store-bar margin-vertical-5"
  }, void 0, footerAppStore.map((icon, index) => /*#__PURE__*/_jsx(Link, {
    href: icon.href,
    target: "_blank",
    rel: "nofollow noopener",
    onClick: e => {
      const data = {
        appStoreName: icon.gaAppStoreName
      };
      onClick(e, data);
    }
  }, index, /*#__PURE__*/_jsx("span", {
    className: "sr-only"
  }, void 0, icon['aria-label']), /*#__PURE__*/_jsx(Image, {
    className: index === 1 ? 'margin-left-4' : '',
    src: icon.src,
    alt: "",
    "aria-hidden": "true",
    lazyload: true,
    height: icon.imgHeight,
    width: icon.imgWidth
  })))), /*#__PURE__*/_jsx("div", {
    className: "icon-bar margin-vertical-5"
  }, void 0, footerSocial && renderSocial(footerSocial)), /*#__PURE__*/_jsx(DisclaimerText, {
    className: "margin-vertical-5 text-center",
    inverse: true
  }, void 0, renderLegal(footerLegal, renderThirdParty)))));
}
export default NonstaticFooter;